var React = require('react');

function NavIconsWorkflows (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m17.72 12h-1.08c0-1.46-1-1.94-2.65-2.56-1.44-.55-3.07-1.16-3.07-3.12h1.08c0 1.16.9 1.55 2.37 2.11s3.35 1.29 3.35 3.57z","key":0}),React.createElement("path",{"d":"m7.26 17.58h-1.08c0-4.95 1.65-6.76 3-8.21a4 4 0 0 0 1.47-2.9h1.08a5 5 0 0 1 -1.73 3.63c-1.31 1.38-2.74 2.95-2.74 7.48z","key":1}),React.createElement("path",{"d":"m17.3 6.75h-11.22v-4.88h11.22zm-10.15-1.08h9.07v-2.67h-9.07z","key":2}),React.createElement("path",{"d":"m22.84 16.28h-11.24v-4.87h11.24zm-10.16-1.08h9.08v-2.71h-9.08z","key":3}),React.createElement("path",{"d":"m12.39 22.13h-11.23v-4.88h11.24zm-10.16-1.08h9.08v-2.72h-9.08z","key":4})]);
}

NavIconsWorkflows.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = NavIconsWorkflows;

NavIconsWorkflows.default = NavIconsWorkflows;
